import axios from "axios"
import * as env from "../constants/env"


/* RSG Reports List */
export const list = (page, search = "", type = "") => {
    const uri = `${env.startpoint}rsg/list?page=${page}&search=${encodeURIComponent(search)}&type=${type}`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}

/* RSG Report Detail */
export const detail = (id) => {
    const uri = `${env.startpoint}rsg/detail?id=${id}`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}

/* Download RSG Report XML File */
export const file = (id) => {
    const uri = `${env.startpoint}rsg/file?id=${id}`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` }, responseType: "blob" }
    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}

/* RSG Games List */
export const games = () => {
    const uri = `${env.startpoint}rsg/games`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}

/* Save RSG Game ID */
export const saveGame = (data) => {
    const uri = `${env.startpoint}rsg/games/save`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Toggle RSG Game */
export const toggleGame = (data) => {
    const uri = `${env.startpoint}rsg/games/toggle`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}
